import { useMutation, useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateVillageMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createVillageApi(data) {
    try {
      const api = `/village`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createVillageApi", ...keyData],
    mutationFn: (data) => createVillageApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("villages");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createVillage: mutateAsync };
}

export function useUpdateVillageMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updateVillageApi(data) {
    try {
      const api = `/village`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }
  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateVillageApi", ...keyData],
    mutationFn: (data) => updateVillageApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("villages");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateVillage: mutateAsync };
}

export function useDeleteVillageMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deleteVillageApi(id) {
    try {
      const api = `/village/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteVillageApi", ...keyData],
    mutationFn: (data) => deleteVillageApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("villages");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteVillage: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllVillageQuery({ query, options = {}, key = "" }) {
  const { getApi } = useAxiosInstance();
  async function getAllVillageApi(query) {
    try {
      const api = `/villages${query ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const {
    data,
    isPending: loading,
    ...rest
  } = useQuery({
    queryKey: [`getAllVillage-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllVillageApi(query),
    ...options
  });
  const newData = data?.data?.data ?? {};
  const parents = data?.data?.parents ?? [];
  return { data: newData, parents, loading, ...rest };
}
